export const accordianEnumArray = [
    {
        "usecaseProfileName": "NotificationBeforePackExpiry",
        "isEnable": true,
        "periodicity": null,
        "duration": null,
        "totalNotification": null,
        "tsHours": null,
        "tsMinutes": null,
        "endHours": null,
        "endMinutes": null,
        "messageText": "",
        "landingPoints": [],
        "usecaseDisplayName": "",
        "usecaseId": 1,
        "userProfileHeader": "Before pack expiry",
        //----------------hide and show tags and box as per requirement--------------
        "isStartdate": false,
        "isduration": true,
        "isperiodicity": true,
        "istime": true,
        "ismessageBody": true,
        "isUserSegmentation": false,
        "tags": {
            "rmn": true,
            "subscriptionEndDate": true,
            "devicetype": false,
            "content_title": false
        },
        "phase": 1
    },
    {
        "usecaseProfileName": "NotificationAfterPackExpiry",
        "isEnable": true,
        "periodicity": null,
        "duration": null,
        "totalNotification": null,
        "tsHours": null,
        "tsMinutes": null,
        "endHours": null,
        "endMinutes": null,
        "messageText": "",
        "landingPoints": [],
        "usecaseDisplayName": "",
        "usecaseId": 2,
        "userProfileHeader": "Post pack expiry",
        //----------------hide and show tags and box as per requirement--------------
        "isStartdate": false,
        "isduration": true,
        "isperiodicity": true,
        "istime": true,
        "ismessageBody": true,
        "isUserSegmentation": false,
        "tags": {
            "rmn": true,
            "subscriptionEndDate": true,
            "devicetype": false,
            "content_title": false
        },
        "phase": 1
    },

    {
        "usecaseProfileName": "NotificationForUnloginAccount",
        "isEnable": true,
        "periodicity": null,
        "duration": null,
        "totalNotification": null,
        "tsHours": null,
        "tsMinutes": null,
        "endHours": null,
        "endMinutes": null,
        "messageText": "",
        "landingPoints": [],
        "usecaseDisplayName": "",
        "usecaseId": 4,
        "userProfileHeader": "App installed but not logged in",
        //----------------hide and show tags and box as per requirement--------------
        "isStartdate": false,
        "isduration": false,
        "isperiodicity": true,
        "istime": true,
        "ismessageBody": true,
        "isUserSegmentation": false,
        "tags": {
            "rmn": false,
            "subscriptionEndDate": false,
            "devicetype": false,
            "content_title": false
        },
        "phase": 1
    },
    {
        "usecaseProfileName": "NotificationForNoContentView",
        "isEnable": true,
        "periodicity": null,
        "duration": null,
        "totalNotification": null,
        "tsHours": null,
        "tsMinutes": null,
        "endHours": null,
        "endMinutes": null,
        "messageText": "",
        "landingPoints": [],
        "usecaseDisplayName": "",
        "usecaseId": 5,
        "userProfileHeader": "App installed but no content view",
        //----------------hide and show tags and box as per requirement--------------
        "isStartdate": true,
        "isduration": false,
        "isperiodicity": true,
        "istime": true,
        "ismessageBody": true,
        "isUserSegmentation": false,
        "tags": {
            "rmn": true,
            "subscriptionEndDate": false,
            "devicetype": false,
            "content_title": false
        },
        "phase": 1
    },
    {
        "usecaseProfileName": "NotificationForRemoveDevice",
        "isEnable": true,
        "periodicity": "",
        "duration": "",
        "totalNotification": "",
        "tsHours": "",
        "tsMinutes": "",
        "endHours": "",
        "endMinutes": "",
        "messageText": "",
        "landingPoints": [],
        "usecaseDisplayName": "",
        "usecaseId": 6,
        "userProfileHeader": "On device change add/remove",
        //----------------hide and show tags and box as per requirement--------------
        "isStartdate": false,
        "isduration": false,
        "isperiodicity": false,
        "istime": false,
        "ismessageBody": true,
        "isUserSegmentation": false,
        "tags": {
            "rmn": false,
            "subscriptionEndDate": false,
            "devicetype": true,
            "content_title": false
        },
        "phase": 1
    },
    //------------------------------phase 2 ------------------------------------
    {
        "usecaseProfileName": "NotificationForLanguageRecommendation",
        "isEnable": true,
        "periodicity": null,
        "duration": null,
        "totalNotification": null,
        "tsHours": null,
        "tsMinutes": null,
        "endHours": null,
        "endMinutes": null,
        "messageText": "",
        "landingPoints": [],
        "usecaseDisplayName": "",
        "usecaseId": 7,
        "userProfileHeader": "Top picks for preferred language",
        //----------------hide and show tags and box as per requirement--------------
        "isStartdate": false,
        "isduration": false,
        "isperiodicity": true,
        "istime": true,
        "ismessageBody": true,
        "isUserSegmentation": false,
        "tags": {
            "rmn": false,
            "subscriptionEndDate": false,
            "devicetype": false,
            "content_title": true
        },
        "phase": 2
    },
    {
        "usecaseProfileName": "NotificationForWatchlistReminder",
        "isEnable": true,
        "periodicity": null,
        "duration": null,
        "totalNotification": null,
        "tsHours": null,
        "tsMinutes": null,
        "endHours": null,
        "endMinutes": null,
        "messageText": "",
        "landingPoints": [],
        "usecaseDisplayName": "",
        "usecaseId": 8,
        "userProfileHeader": "Watchlist reminder",
        //----------------hide and show tags and box as per requirement--------------
        "isStartdate": false,
        "isduration": false,
        "isperiodicity": true,
        "istime": true,
        "ismessageBody": true,
        "isUserSegmentation": true,
        "tags": {
            "rmn": false,
            "subscriptionEndDate": false,
            "devicetype": false,
            "content_title": true
        },
        "phase": 2
    },
    {
        "usecaseProfileName": "NotificationForContinueWatching",
        "isEnable": true,
        "periodicity": null,
        "duration": null,
        "totalNotification": null,
        "tsHours": null,
        "tsMinutes": null,
        "endHours": null,
        "endMinutes": null,
        "messageText": "",
        "landingPoints": [],
        "usecaseDisplayName": "",
        "usecaseId": 9,
        "userProfileHeader": "Pick where you left",
        //----------------hide and show tags and box as per requirement--------------
        "isStartdate": false,
        "isduration": false,
        "isperiodicity": true,
        "istime": true,
        "ismessageBody": true,
        "isUserSegmentation": false,
        "tags": {
            "rmn": false,
            "subscriptionEndDate": false,
            "devicetype": false,
            "content_title": true
        },
        "phase": 2
    },

    {
        "usecaseProfileName": "NotificationForGenereRecommendation",
        "isEnable": true,
        "periodicity": null,
        "duration": null,
        "totalNotification": null,
        "tsHours": null,
        "tsMinutes": null,
        "endHours": null,
        "endMinutes": null,
        "messageText": "",
        "landingPoints": [],
        "usecaseDisplayName": "",
        "usecaseId": 10,
        "userProfileHeader": "Top picks for preferred genre",
        //----------------hide and show tags and box as per requirement--------------
        "isStartdate": false,
        "isduration": false,
        "isperiodicity": true,
        "istime": true,
        "ismessageBody": true,
        "isUserSegmentation": false,
        "tags": {
            "rmn": false,
            "subscriptionEndDate": false,
            "devicetype": false,
            "content_title": true
        },
        "phase": 2
    },
    {
        "usecaseProfileName": "NotificationForBYWRecommendation",
        "isEnable": true,
        "periodicity": null,
        "duration": null,
        "totalNotification": null,
        "tsHours": null,
        "tsMinutes": null,
        "endHours": null,
        "endMinutes": null,
        "messageText": "",
        "landingPoints": [],
        "usecaseDisplayName": "",
        "usecaseId": 11,
        "userProfileHeader": "Top picks for based on before you watched",
        //----------------hide and show tags and box as per requirement--------------
        "isStartdate": false,
        "isduration": false,
        "isperiodicity": true,
        "istime": true,
        "ismessageBody": true,
        "isUserSegmentation": false,
        "tags": {
            "rmn": false,
            "subscriptionEndDate": false,
            "devicetype": false,
            "content_title": true
        },
        "phase": 2
    },
]

export const priodicityArray = ["DAILY", "ALTERNATE_DAYS"];
export const priodicityArrayPhase2 = ["DAILY", "ALTERNATE_DAYS", "SPECIFIC_DAYS"];
export const weekDaysArray = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];


export const buttonNames = {
    rmn: '<RMN>',
    subscriptionEndDate: '<EXPIRY_DATE>',
    devicetype: '<DEVICE_TYPE>',
    //------------------------------phase 2 ------------------------------------
    content_title: '<CONTENT_TITLE>'
}


export const toolTip = [
    {
        usecaseProfileName: "NotificationBeforePackExpiry",
        duration: 'Number of days before user pack expires',
        periodicity: 'The tendency to recur at intervals',
        time: 'Enter start time',
        message_body: 'Enter message to send notification to user'
    },
    {
        usecaseProfileName: "NotificationAfterPackExpiry",
        duration: 'From the date when pack expires for how many days we should send reminder to the end user to buy the subscription',
        periodicity: 'The tendency to recur at intervals',
        time: 'Enter start time',
        message_body: 'Enter message to send notification to user'
    },
    {
        usecaseProfileName: "NotificationForUnloginAccount",
        periodicity: 'The tendency to recur at intervals',
        time: 'Enter start time',
        message_body: 'Enter message to send notification to user',
        start_date: 'The application has been installed, but the user has not logged in for a certain number of days.'//We will provide the business team with the ability to configure this duration. For example, if a user has installed the app but has not logged in for 1, 2, 3, 4, or 5 days, we should begin sending notifications encouraging them to use our app.
    },
    {
        usecaseProfileName: "NotificationForNoContentView",
        periodicity: 'The tendency to recur at intervals',
        time: 'Enter start time',
        message_body: 'Enter message to send notification to user',
        start_date: 'The application has been installed, but the user has not viewed any content for a certain number of days.'// We will empower the business team to define this duration. For instance, if a user has installed the app but hasn't viewed any content in the last 1, 2, 3, 4, or 5 days, we should initiate notifications encouraging them to explore the app's content.'
    },
    {
        usecaseProfileName: "NotificationForRemoveDevice",
        message_body: 'Enter message to send notification to user'
    },
    //------------------------------phase 2 ------------------------------------
    {
        usecaseProfileName: "NotificationForLanguageRecommendation",
        periodicity: 'The tendency to recur at intervals',
        time: 'Enter start time',
        message_body: 'Enter message to send notification to user',
    },
    {
        usecaseProfileName: "NotificationForWatchlistReminder",
        periodicity: 'The tendency to recur at intervals',
        time: 'Enter start time',
        message_body: 'Enter message to send notification to user',
    },
    {
        usecaseProfileName: "NotificationForContinueWatching",
        periodicity: 'The tendency to recur at intervals',
        time: 'Enter start time',
        message_body: 'Enter message to send notification to user',
    },
    {
        usecaseProfileName: "NotificationForGenereRecommendation",
        periodicity: 'The tendency to recur at intervals',
        time: 'Enter start time',
        message_body: 'Enter message to send notification to user',
    },
    {
        usecaseProfileName: "NotificationForBYWRecommendation",
        periodicity: 'The tendency to recur at intervals',
        time: 'Enter start time',
        message_body: 'Enter message to send notification to user',
    },


]


export const criteria = [
    "Subscribed User",
    "Unsubscribed User",
    "All User", "Subscriber with Mega Pack",
    "Watched Content within 3 days",
    "Not Watched Content Within 3 Days",
    "Content Added In Watch List Past 7 Days",
    "No Content Added In Past 7 Days",
]
